import { TravelPricing } from './../../common/models/TravelPrincing';
import { BaseCrudService } from '@t-llevo/common-ui';
import { Inject, Injectable } from '@angular/core';
import { Environment, ResponseData } from '@t-llevo/util';
import { HttpClient } from '@angular/common/http';
import { TravelPricingResponse } from '../models/responses/TravelPricingResponse';
import { TravelPricingMapper } from '../mappers/TravelPricingMapper';
import { apiTravelPricingRoutes } from '../routes/api-travel-pricing-routes';
import { TravelPricingRequest } from '../models/requests/TravelPricingRequest';
import { switchMap } from 'rxjs';

export interface TravelPricingFormData {
  general: {
    vehicleType: string;
    currency: string;
    baseFee: number;
    costPerKm: number;
  };
  rule: {
    weekDay: string;
    validTimeRangeStart: string;
    validTimeRangeEnd: string;
    geofence: string;
  };
  extra: {
    costPerMinute: number;
    pickupFee: number;
    dropoffFee: number;
    surgeMultiplier: number;
    minimumFare: number;
    cancellationFee: number;
    distanceThresholdKm: number;
  };
}

@Injectable()
export class TravelPricingService extends BaseCrudService<
  TravelPricing,
  ResponseData<TravelPricingResponse>
> {
  constructor(@Inject(Environment) env: Environment, http: HttpClient) {
    super(env, http);
  }

  override transform(data: ResponseData<TravelPricingResponse>) {
    return {
      ...data,
      results: data.results.map((pricing) => TravelPricingMapper(pricing)),
    };
  }

  createPrice(params: TravelPricingRequest) {
    return this.http.post<TravelPricingResponse>(
      ` ${this.env.apiUrl}${apiTravelPricingRoutes.routePricing}`,
      params
    );
  }

  updatePrice(params: TravelPricingRequest, id: string) {
    return this.http.put<TravelPricingResponse>(
      `${this.env.apiUrl}${apiTravelPricingRoutes.routePricing}/${id}`,
      params
    );
  }

  deletePriceById(id: string) {
    return this.http.delete(
      `${this.env.apiUrl}${apiTravelPricingRoutes.routePricing}/${id}`
    );
  }

  changePricingActiveStatusById(id: string) {
    return this.http
      .get<TravelPricingResponse>(
        `${this.env.apiUrl}${apiTravelPricingRoutes.routePricing}/${id}`
      )
      .pipe(
        switchMap((data) => {
          return this.http.put<TravelPricingResponse>(
            `${this.env.apiUrl}${apiTravelPricingRoutes.routePricing}/${id}`,
            {
              ...data,
              is_active: !data.is_active,
            }
          );
        })
      );
  }
}
